export const categories = [
  {
    id: "ent",
    name: "娱乐爆料",
    desc: "综艺、影视与行业动态的公开线索，按时间顺序整理。",
    icon: "ri-mic-line",
  },
  {
    id: "soc",
    name: "社会热议",
    desc: "公共话题中的多方说法集中对照，还原讨论起点。",
    icon: "ri-building-2-line",
  },
  {
    id: "rights",
    name: "消费维权",
    desc: "消费纠纷的完整经过、处理路径与可复用经验。",
    icon: "ri-shield-check-line",
  },
  {
    id: "work",
    name: "职场观察",
    desc: "职场事件与行业现象的观察，看清背后的常见逻辑。",
    icon: "ri-briefcase-line",
  },
  {
    id: "scene",
    name: "网络现场",
    desc: "网络流传内容的真伪辨别与背景补充，避免被带节奏。",
    icon: "ri-live-line",
  },
  {
    id: "deep",
    name: "深度梳理",
    desc: "热点事件的完整脉络与背景解读，一次性看懂。",
    icon: "ri-file-search-line",
  },
];